import { render, staticRenderFns } from "./Facilities.vue?vue&type=template&id=3e4d2a21&scoped=true"
import script from "./Facilities.vue?vue&type=script&lang=js"
export * from "./Facilities.vue?vue&type=script&lang=js"
import style0 from "./Facilities.vue?vue&type=style&index=0&id=3e4d2a21&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4d2a21",
  null
  
)

export default component.exports